export default "__VITE_ASSET__C_vtF8vc__"